import React from 'react';
import groupBy from 'lodash/groupBy';
import ThemedSelect from '../../misc/ThemedSelect';
import { collectOptionByType, countNestedOptions } from './utils';
function pickColorOptions(defaultOption, modelByStatus) {
    var optgroups = [];
    optgroups.push({
        label: 'Defaults',
        options: [
            {
                value: defaultOption,
                label: 'Default color'
            }
        ]
    });
    var ownOptions = collectOptionByType(modelByStatus.own, [
        'category',
        'boolean'
    ]);
    if (ownOptions.length > 0) {
        optgroups.push({
            label: 'Categorical attributes',
            options: ownOptions
        });
    }
    var computedOptions = collectOptionByType(modelByStatus.computed, 'category');
    if (computedOptions.length > 0)
        optgroups.push({ label: 'Computed categories', options: computedOptions });
    return optgroups;
}
function pickSizeOptions(defaultOption, modelByStatus) {
    var optgroups = [];
    if (defaultOption === null) {
        optgroups.push({
            label: 'Defaults',
            options: [
                {
                    value: defaultOption,
                    label: 'Default size'
                }
            ]
        });
    }
    else {
        optgroups.push({
            label: 'Defaults',
            options: [
                {
                    value: null,
                    label: 'Constant size'
                },
                {
                    value: defaultOption,
                    label: "Default size (".concat(defaultOption, ")")
                }
            ]
        });
    }
    var ownOptions = collectOptionByType(modelByStatus.own, 'number');
    if (ownOptions.length > 0) {
        optgroups.push({
            label: 'Numerical attributes',
            options: ownOptions
        });
    }
    var computedOptions = collectOptionByType(modelByStatus.computed, 'number');
    if (computedOptions.length > 0)
        optgroups.push({ label: 'Computed metrics', options: computedOptions });
    return optgroups;
}
export default function EdgeVariables(_a) {
    var model = _a.model, variables = _a.variables, actions = _a.actions, defaultEdgeColor = _a.defaultEdgeColor, defaultEdgeSize = _a.defaultEdgeSize;
    var modelByStatus = groupBy(model, 'kind');
    var colorOptions = pickColorOptions(defaultEdgeColor, modelByStatus);
    var sizeOptions = pickSizeOptions(defaultEdgeSize, modelByStatus);
    return (React.createElement("div", { className: "variables-block" },
        React.createElement("h6", { className: "title is-6 block-title" }, "Edges"),
        React.createElement("div", { className: "columns" },
            React.createElement("div", { className: "column is-4" }, "color"),
            React.createElement("div", { className: "column is-8" },
                React.createElement(ThemedSelect, { options: colorOptions, value: variables.color, isDisabled: countNestedOptions(colorOptions) < 2, onChange: function (option) { return actions.setEdgeColor(option.value); } }))),
        React.createElement("div", { className: "columns" },
            React.createElement("div", { className: "column is-4" }, "size"),
            React.createElement("div", { className: "column is-8" },
                React.createElement(ThemedSelect, { options: sizeOptions, value: variables.size, isDisabled: countNestedOptions(sizeOptions) < 2, onChange: function (option) { return actions.setEdgeSize(option.value); } })))));
}
